/** The newsletter opt-in on the sign-up screens (web and desktop). */
export default {
  productEmailsLabel: "Email me product news and tips",
  productEmailsHint: "Unsubscribe anytime.",
} as const;
